/** 本人请求记录的纯读口；不依赖生图供应商是否可画，不恢复退役 POST。 */
import type { ApiClient } from "@/shared/api/client";
import { ApiError } from "@/shared/api/errors";
import type { PhotoAskPage } from "@/shared/contracts";

export interface PhotoAskStatusService {
  latest(petId: string, signal: AbortSignal): Promise<PhotoAskPage>;
}

export function livePhotoAskStatusService(api: ApiClient): PhotoAskStatusService {
  return {
    latest: (petId, signal) => api.request<PhotoAskPage>(
      `/communicator/${encodeURIComponent(petId)}/photo-asks`,
      { method: "GET", query: { limit: 30 }, signal },
    ),
  };
}

export function demoPhotoAskStatusService(): PhotoAskStatusService {
  return { latest: async () => { throw ApiError.capability("communicator.photo_asks", "演示里没有真实的照片请求记录。"); } };
}
